import { Button, Col, Modal, ModalProps, Row } from 'react-bootstrap';

type Props = {
  type: string;
  name: string;
  onConfirm: () => void;
} & ModalProps;

const DeleteVanityModal = ({ type, name, show, onHide, onConfirm }: Props) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Body>
        <Row className="mt-4">
          <Col className="text-center">
            Delete {name} {type}?
          </Col>
        </Row>
        <Row style={{ display: 'flex', justifyContent: 'space-around' }} className="mt-5 pl-1">
          <Button variant="success" className="w-30" onClick={onConfirm}>
            Confirm
          </Button>
          <Button className="w-30" onClick={onHide}>
            Cancel
          </Button>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteVanityModal;
